<template>
  <!-- 客户提现 -->
  <div class="opage">
    <div>
      <!-- 客户提现 -->
      <baseBreadcrumb :page="$t('message.clientsSun')" :menu="$t('message.money')"></baseBreadcrumb>
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <!-- 待业务确认 -->
          <el-tab-pane :label="`${$t('message.pendingBusinessConfirmation')}`" name="1"> </el-tab-pane>
          <!-- 待审核 -->
          <el-tab-pane :label="`${$t('message.toBeReviewed')}`" name="2"> </el-tab-pane>
          <!-- 等待打款 -->
          <el-tab-pane :label="$t('message.waitingForPayment')" name="3"> </el-tab-pane>
          <!-- 客户确认 -->
          <el-tab-pane :label="$t('message.customerConfirmation')" name="4"> </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 订单号.派送单号 -->
          <div class="item">
            <!-- 客户ID -->
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable>
            </el-input>
          </div>
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.filter") }}
          </el-button>
          <!-- 重置 -->
          <!-- <el-button @click="reset">
            {{ $t("message.reset") }}
            
          </el-button> -->
          <!-- 新增 -->
          <div class="add">
            <!-- 复制提现链接 -->
            <el-button type="primary" @click="copy('https://www.rakumart.com/WithdrawDeposit')">
              {{ $t("message.copyTheWithdrawalLink") }}
            </el-button>
            <el-button type="primary" @click="add">
              {{ $t("message.add") }}
            </el-button>
          </div>


        </div>
      </div>
      <div class="body">
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 申请提现时间 -->
            <li v-if="datas.status == 1">{{ $t("message.applicationTime") }}</li>
            <!-- 业务确认时间 -->
            <li v-if="datas.status == 2">{{ $t("message.businessConfirmationTime") }}</li>
            <!-- 部长审核时间 -->
            <li v-if="datas.status == 3">{{ $t("message.ministerReviewTime") }}</li>
            <!-- 汇款时间 -->
            <li v-if="datas.status == 4">{{ $t("message.remittanceTime") }}</li>

            <!-- 申请人信息 -->
            <li class="flex15">{{ $t("message.applicantInformation") }}</li>
            <!-- 账户余额.円 -->
            <li>{{ $t("message.accountBalanceYen") }}</li>
            <!-- 申请提现金额.円 -->
            <li>{{ $t("message.applyWithdrawalAmountYen") }}</li>
            <!-- 手续费承担 -->
            <li>{{ $t("message.commissionCommitment") }}</li>
            <!-- 申请人银行账户信息 -->
            <li class="flex2">
              {{ $t("message.ApplicantsBankAccountInformation") }}
            </li>
            <!-- 提醒次数 -->
            <li>{{ $t("message.reminderTimes") }}</li>

            <!-- 状态 -->
            <li>{{ $t("message.status") }}</li>

            <!--  打款信息-->
            <li class="flex15">{{ $t("message.paymentInformation") }}</li>
            <!-- 沟通截图 -->
            <li>{{ $t("message.communicationScreensho") }}</li>
            <!-- 业务备注 -->
            <li>{{ $t("message.serviceRemarks") }}</li>
            <!-- 审核备注 -->
            <li>{{ $t("message.auditRemarks") }}</li>
            <!-- 操作 -->
            <li>{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index" :class="{ current: item.current_cash_count_over > 2 }">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 申请提现时间 -->
            <li style="text-align: center;" v-if="datas.status == 1">{{ item.created_at }}</li>
            <!-- 业务确认时间 -->
            <li v-if="datas.status == 2" style="text-align: center;">{{ item.y_edit_at }}</li>
            <!-- 部长审核时间 -->
            <li v-if="datas.status == 3" style="text-align: center;">{{ item.y_confirm_at }}</li>
            <!-- 汇款时间 -->
            <li v-if="datas.status == 4" style="text-align: center;">{{ item.confirm_at }}</li>
            <!-- 申请人信息 -->
            <li class="flex15">
              <div class="keHu">
                <!-- 客户名 -->
                <p>
                  <attributeName :name="item.user.attribute_name" />
                </p>
                <p>
                  {{ $t("message.customerName") }}:
                  <router-link
                    :to="'/user/basicInformation?userID=' + item.user_id + '&encryption=' + $md5(item.user_id + '')"
                    target="_blank" class="a-link">
                    {{ item.user.realname }}
                  </router-link>
                </p>

                <p style="display: flex;">ID:{{ item.user_id }}
                  <img src="@/assets/icon/illegal.png" alt="" slot="reference"
                    style="vertical-align: middle; width: 30px;" v-if="item.user.user_tag != false">
                  <!-- 联系方式 -->
                  <!-- 信息查看 -->
                  <!-- <el-popover popper-class="zdyPopver" placement="bottom-start" trigger="click"
                    :title="$t('message.customerContactInformation') + ':'">
                    <div class="xianShiLXXX">
                      <p>Email：{{ item.user.email }}</p>
                      <p>Mobile：{{ item.user.mobile }}</p>
                    </div>
                 
                    <p class="lianXiFangShi redFont" slot="reference" style="margin-left: 10px;">
                      {{ $t("message.CheckInformation") }}
                    </p>
                  </el-popover> -->
                </p>
                <p>
                  {{ $t("message.salesman") }} ： {{ item.user.y_admin.realname }}
                </p>
                <!-- 部门 -->
                <p>
                  {{ $t("message.department") }} ： {{ item.user.y_admin.role[0].name }}
                </p>
              </div>
            </li>
            <!-- 账户余额.円 -->
            <li>{{ item.user.balance }}</li>
            <!-- 申请提现金额.円 -->
            <li>{{ item.client_amount }}</li>
            <!-- 手续费承担 -->
            <li>
              {{ item.y_edit_fee_payer ? 'RAKUMART' : $t('message.user') }}
            </li>
            <!-- 申请人银行账户信息 -->
            <li class="flex2">
              <div class="temlate">
                <p>银行名：{{ item.client_bank_name }}</p>
                <p>支店番号：{{ item.client_bank_branch_no }}</p>
                <p>支店名:{{ item.client_bank_branch_name }}</p>
                <p>預金種目 :{{ item.client_pay_type }}</p>
                <p>口座番号:{{ item.client_account }}</p>
                <p>口座名義: {{ item.client_bank_username }}</p>
                <p>返金原因: {{ item.client_reason }}</p>
              </div>
            </li>
            <!-- 提醒次数 -->
            <li>
              <span>{{ item.current_cash_count_over }}</span>
            </li>
            <!-- 状态 -->
            <li>{{ item.status_name }}</li>
            <!-- 打款信息 -->
            <li class="flex15">
              <div>
                <p>{{ item.pay_bank_name }}</p>
                <a :href="item.pay_image" target="_blank" rel="noopener noreferrer" class="a-link">
                  {{ getFileName(item.pay_image) }}
                </a>
              </div>
            </li>
            <!-- 沟通截图 -->
            <li>
              <el-image style="width: 80%; " :src="item.y_edit_image" v-if="item.y_edit_image"
                :preview-src-list="[item.y_edit_image]">
              </el-image>
            </li>
            <!-- 业务备注 -->
            <li>{{ item.y_edit_remark }}</li>
            <!-- 审核备注 -->
            <li>{{ item.y_confirm_remark }}</li>
            <!-- 操作 -->
            <li>
              <div class="btnGroup">
                <!-- 业务确认 -->
                <el-button type="primary" class="secondary" size="small" @click="verify(item)"
                  v-if="isAuth(515) && item.status == '1'">
                  {{ $t("message.serviceConfirmation") }}
                </el-button>
                <!-- 审核 -->
                <el-button type="primary" class="secondary" size="small" @click="examine(item)"
                  v-if="isAuth(516) && item.status == '2'">
                  {{ $t("message.examine") }}
                </el-button>
                <!-- 汇款 -->
                <el-button type="primary" class="secondary" size="small" @click="cashConfirm(item)"
                  v-if="isAuth(326) && item.status == '3'">
                  {{ $t("message.remittance") }}
                </el-button>
                <!-- 取消申请 -->
                <el-button size="small" type="primary" class="dark" @click="cashRefuse(item)"
                  v-if="isAuth(327) && item.status != '4'">
                  {{ $t("message.cancellationRequest") }}
                </el-button>
              </div>
            </li>
          </ul>
          <!-- 确认汇款和拒绝汇款弹窗  这两个弹窗写在一起,使用submissionType变量控制显示表单 -->
          <zDialog ref="cashConfirmDia" :config="config">
            <div class="editForm">
              <el-form ref="ruleForm" :model="remittanceInformation" :rules="rules" label-position="left"
                label-width="128px">
                <template v-if="submissionType == 'cashConfirm'">
                  <!-- 支付方式 -->
                  <el-form-item :label="$t('message.methodPayment') + ':'" prop="pay_method">
                    <el-select @change="validateField('pay_method', 'ruleForm')"
                      v-model="remittanceInformation.pay_method" :placeholder="$t('message.methodPayment')">
                      <el-option v-for="item in cashBanksList" :key="item.key" :label="item.value" :value="item.key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 打款凭证 -->
                  <el-form-item :label="$t('message.paymentVoucher') + ':'" prop="image">
                    <div class="imgUp">
                      <el-upload :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                        :on-success="handleAvatarSuccess" name="file" accept=".jpg,.jpeg,.png"
                        :before-upload="beforeAvatarUpload">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-image :src="remittanceInformation.image" v-if="remittanceInformation.image"
                        style="width: 80px; height: 80px">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                        <div slot="placeholder">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </div>
                  </el-form-item>
                </template>
                <template v-else>
                  <!-- 拒绝原因 -->
                  <el-form-item :label="$t('message.reasonForRejection') + ':'" prop="refuse_reason">
                    <el-input class="remarksTextBox" type="textarea" v-model="remittanceInformation.refuse_reason">
                    </el-input>
                  </el-form-item>
                </template>
              </el-form>
            </div>
          </zDialog>
          <!-- 暂无数据 -->
          <div v-if="tableData == false" class="No_data">
            {{ $t("message.noDataYet") }}
          </div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增提现 -->
    <addCustomerWithdrawal ref="add" />
    <!-- 业务确认 -->
    <serviceConfirmation ref="serviceConfirmation" :id="itemData.id" />
    <!-- 审核 -->
    <examine ref="examine" :id="itemData.id" />
  </div>
</template>
<script>
import addCustomerWithdrawal from './components/addCustomerWithdrawal.vue'
import serviceConfirmation from './components/serviceConfirmation'
import examine from './components/examine'
export default {
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      datas: {
        status: this.$route.query.status ? this.$route.query.status : '1',
      },
      tableData: [],
      total: 0,
      cashBanksList: [], //支付方式列表
      config: {
        top: "20vh",
        width: "536px",
        autoClose: false,
        // 修改：
        title: this.$t("message.edit"),
        btnTxt: [this.$t("message.confirm"),],
      },
      remittanceInformation: {}, //表单信息
      rules: {
        // 支付方式
        pay_method: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 汇款截图
        image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),

          },
        ],
        // 拒绝原因
        refuse_reason: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      }, //表单验证规则
      submissionType: "cashConfirm",
      itemData: {},
    };
  },
  components: {
    addCustomerWithdrawal, serviceConfirmation, examine
  },
  created() {
    this.cashList();
    this.cashBanks();
    this.clientCashOutNum()
  },
  methods: {
    clientCashOutNum() {
      this.$api.tabTotalApi.clientCashOutNum().then(res => {
        this.tabs = res.data
      })
    },
    // 获取支付方式列表
    cashBanks() {
      this.$api.financialApi.cashBanks().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.cashBanksList = res.data;
      });
    },
    // 重置提交表单
    resetForm() {
      this.remittanceInformation = {}
    },
    // 确认请求
    cashConfirm(item) {
      this.submissionType = "cashConfirm";
      this.config.title = this.$t('message.remittance') //汇款 
      this.$refs.cashConfirmDia.open("", () => {
        this.$refs.ruleForm.validate((valid) => { //验证表单
          if (valid) {
            this.$api.financialApi.cashConfirm({
              id: item.id,
              image: this.remittanceInformation.image,
              pay_method: this.remittanceInformation.pay_method
            }).then((res) => {
              if (res.code != 0) return this.$message.error(res.data.msg);
              this.$refs.cashConfirmDia.close()//关闭弹窗
              //接下来的操作
              this.cashList();
              this.resetForm()
              this.clientCashOutNum()
            });
          }
        })

      });
    },
    // 拒绝请求
    cashRefuse(item) {
      this.submissionType = "cashRefuse";
      this.config.title = this.$t('message.cancellationRequest') //汇款 
      this.$refs.cashConfirmDia.open("", () => { //打开弹窗
        this.$refs.ruleForm.validate((valid) => { //验证表单
          if (valid) {
            //文本: 确认后，该提现申请将被取消。需要申请人重新提出申请，请确认！
            this.$confirm(   //确认是否删除
              this.$t("message.declineWithdrawalPrompts"),
              this.$t("message.prompt"),
              {
                confirmButtonText: this.$t("message.ok"),
                cancelButtonText: this.$t("message.cancel"),
                type: "warning",
              }
            )
              .then(() => {
                this.$api.financialApi
                  .cashRefuse({
                    id: item.id,
                    refuse_reason: this.remittanceInformation.refuse_reason,
                  })
                  .then((res) => {
                    if (res.code != 0) return this.$message.error(res.data.msg);
                    //接下来的操作
                    this.cashList();
                    this.resetForm()
                    this.clientCashOutNum()
                    this.$refs.cashConfirmDia.close()//关闭弹窗
                    this.$message({
                      type: "success",
                      message: this.$t("message.refuseToSucceed"),
                    });
                  });
              })
              .catch(() => {
                this.$refs.cashConfirmDia.close()//关闭弹窗
                //this.$message({
                //type: 'info',
                //message: '已取消删除'
                //});
              });
          } else {

          }
        });

      });
    },
    // 获取链接里的文件名
    getFileName(url) {
      let str = url.split("/");
      // str = str.slice(str.length - 1, str.length).toString(String).split(".");
      str = str.slice(str.length - 1, str.length);
      return str[0];
    },
    // 重置
    reset() {
      this.datas = {};
      this.cashList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.cashList();
    },
    // 获取配送单列表
    cashList() {
      // 因为el-tabs组件在name绑定为空值时会设置绑定值为0,但是接口没有设置返回所有数据的参数,所以需要判断删除
      // if (this.datas.status == '0') {
      //   delete this.datas.status
      // }
      this.$api.financialApi.cashList(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    handleAvatarSuccess(res, file) {

      this.loading.close();
      this.remittanceInformation.image = res.data;
      this.$forceUpdate()
      // this.validateField("image", "ruleForm");
    },
    // 手动触发表单验证
    validateField(type, formRef) {
      this.$refs[formRef].validateField(type, (v) => {
        if (v == "") {
        } else {
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;

      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.cashList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.cashList();
    },
    //新增
    add() {
      this.$refs.add.dialogVisible = true

    },
    //确认
    verify(item) {
      this.itemData = item
      this.$refs.serviceConfirmation.dialogVisible = true
    },
    //审核
    examine(item) {
      this.itemData = item
      this.$refs.examine.dialogVisible = true
    },
  },
};

</script>
<style lang="scss" scoped>
.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}



.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.search {
  margin: 24px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    margin-bottom: 16px;


    .item {
      width: 240px;
      margin-right: 24px;
    }

    .add {
      position: absolute;
      top: 0;
      right: 20px;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
    align-items: center;

    >* {
      margin-bottom: 26px;
    }
  }
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    .temlate {
      width: 100%;
      text-align: left;
      // max-height: 100px;
      overflow-y: auto;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    // height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5 !important;
    word-break: break-all;
  }

  .flex2 {
    flex: 3 !important;
    word-break: break-all;
  }

  .current {

    background-color: rgba(242, 210, 235, 0.5) !important;
  }
}

.keHu {
  width: 100%;

  p {
    text-align: left;
  }
}

.xianShiLXXX {
  padding: 16px;

  p {
    font-size: 14px;
    line-height: 20px;
    padding: 5px;
    display: flex;
    align-items: center;
  }

  /deep/.el-image,
  .payImg {
    $imgSize: 80px;
    width: $imgSize;
    height: $imgSize;
    transition: 0.3s;
    text-align: center;

    i {
      font-size: $imgSize/4;
      line-height: $imgSize;
    }
  }
}

.lookMore {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.btnGroup {
  display: flex;
  justify-content: center;
  flex-direction: column;

  .el-button {
    display: flex;
    justify-content: center;
    margin: 0 0 8px 0;
  }
}

.editForm {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px 24px 1px;

  .el-select {
    width: 100%;
  }

  .imgUp {
    display: flex;
    align-items: flex-start;

    /deep/ .el-upload {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: white;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    /deep/.el-image {
      width: 80px !important;
      height: 80px !important;
    }

    /deep/.imgBox {
      height: 80px;
    }
  }

  /deep/.remarksTextBox {
    .el-textarea__inner {
      height: 100px;
      background: #ffffff;
      border: 1px solid #edeff4;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      padding: 12px 16px;
    }
  }
}
</style>
